module.exports = "query getFieldOfLaw($id:String!){fieldOfLaw(id:$id){name id}}"